import { useState } from "react";
import classes from "./Login.module.scss";
import auth from "../../util/auth";

export const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!username.trim() || !password) {
      if (!username.trim() && !password) {
        setError("Username and password are required.");
      } else if (!username.trim()) {
        setError("Username is required.");
      } else {
        setError("Password is required.");
      }
      return;
    }

    try {
      const userData = await auth.login({
        username,
        password,
      });

      window.localStorage.setItem("loggedBLUser", userData.token);
      window.localStorage.setItem("faction", userData.faction);

      setUser(userData);
      setUsername("");
      setPassword("");
      window.location.reload();
    } catch (error) {
      const status = error?.response?.status;
      const data = error?.response?.data;
      if (status === 429) {
        setError("Too many login attempts. Please try again after 20 minutes.");
      } else {
        setError(data?.error || "Incorrect username or password.");
      }
    }
  };

  return (
    <div className={classes.login}>
      <form onSubmit={handleLogin}>
        <h2>Renaissance Kingdoms Maps</h2>
        {error && <p className={classes.error}>{error}</p>}
        <div className={classes.group}>
          <label>Name:</label>
          <input
            type="text"
            placeholder="Name"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className={classes.group}>
          <label>Password:</label>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <input type="submit" className={classes.btn} value="Log in" />
      </form>
    </div>
  );
};
